
import { computed, defineComponent, ref, watch } from "vue";
import moment from "moment";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n/index";
import machine_video_modal from "./machine_video_modal.vue";
import AchivementModal from "@/components/achivements/modal.vue"
import apiService from "@/core/services/ApiService";

export default defineComponent({
  name: "machine_activity",
  components: { machine_video_modal, AchivementModal },
  data() {
    return {
    };
  },
  computed: {
    percentage() {
      return this.machine.percentage;
    },
    attachments() {
      const items = this.machine?.attachments || [];
      if (!items.length) return [];

      if (this.currentLanguage == 'pt') {
        return items.filter((attachment: any) =>
          attachment.type == 'video' ||
          attachment.type == 'link' ||
          !attachment.name.includes('.pdf') ||
          ((attachment.type == 'doc' || attachment.type == 'machine') && (attachment.metadata == null || attachment.metadata.language == 'pt'))
        )
      }
      return items.filter((attachment: any) =>
        attachment.type == 'video' ||
        attachment.type == 'link' ||
        !attachment.name.includes('.pdf') ||
        ((attachment.type == 'doc' || attachment.type == 'machine') && (attachment.metadata?.language == 'en'))
      );
    }
  },
  props: {
    machine: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const store = useStore();
    const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));
    const user = computed(() => store.getters.currentUser);
    const achivementModal = ref(null);
    const userStats = ref({})
    const getUserStats = async () => {
      try {
        const { data } = await apiService.vueInstance.axios.get("/user-stats/machines/" + props.machine.id);
        userStats.value = data;
      } catch (error) {
        console.error('Error fetching user stats:', error);
      }
    }

    watch(() => props.machine, async (newMachine, oldMachine) => {
      if (newMachine && newMachine.percentage == 100 && oldMachine && oldMachine.percentage < 100) {
        if (achivementModal.value) {
          await getUserStats();
          //@ts-ignore
          achivementModal.value.open();
        }
      }
    }, { immediate: true });

    return {
      moment,
      currentLanguage,
      user,
      achivementModal,
      userStats,
      getUserStats
    };
  },
  methods: {
    openVideoModal(video, title) {
      const videoModal = this.$refs.videModal as InstanceType<typeof machine_video_modal>;
      if (videoModal) {
        videoModal.showModal(video, title);
      }
    },
    async explode() {
      const achivementModal = this.$refs.achivementModal as InstanceType<typeof AchivementModal>;
      if (achivementModal) {
        await this.getUserStats();
        await achivementModal.open();
      }
    },
    shareOnLinkedin(machine_id, user_id) {
      const url = `${process.env.VUE_APP_SHARE_URL}achievement/machine/${machine_id}/user/${user_id}`;
      const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
      window.open(linkedinUrl, "_blank");
    }
  }
});
